// extracted by mini-css-extract-plugin
export default {"container":"DynamicToggle_container__xoAiW","label":"DynamicToggle_label__MpVnz"};